__turbopack_context__.v({
  "body": "WLatestBlogPosts-module__eJ-FTq__body",
  "cardTitle": "WLatestBlogPosts-module__eJ-FTq__cardTitle",
  "excerpt": "WLatestBlogPosts-module__eJ-FTq__excerpt",
  "grid": "WLatestBlogPosts-module__eJ-FTq__grid",
  "header": "WLatestBlogPosts-module__eJ-FTq__header",
  "heading": "WLatestBlogPosts-module__eJ-FTq__heading",
  "inner": "WLatestBlogPosts-module__eJ-FTq__inner",
  "left": "WLatestBlogPosts-module__eJ-FTq__left",
  "leftImageWrap": "WLatestBlogPosts-module__eJ-FTq__leftImageWrap",
  "readMore": "WLatestBlogPosts-module__eJ-FTq__readMore",
  "right": "WLatestBlogPosts-module__eJ-FTq__right",
  "root": "WLatestBlogPosts-module__eJ-FTq__root",
  "showAllBtn": "WLatestBlogPosts-module__eJ-FTq__showAllBtn",
  "sideBody": "WLatestBlogPosts-module__eJ-FTq__sideBody",
  "sideCard": "WLatestBlogPosts-module__eJ-FTq__sideCard",
  "sideImage": "WLatestBlogPosts-module__eJ-FTq__sideImage",
  "sideImageWrap": "WLatestBlogPosts-module__eJ-FTq__sideImageWrap",
  "titleLink": "WLatestBlogPosts-module__eJ-FTq__titleLink",
});
